import React from 'react';
import Icon from '../../../components/AppIcon';

const EmployeeSpotlight = ({ employee }) => {
  return (
    <div className="bg-white rounded-xl shadow-soft overflow-hidden">
      <div className="relative">
        <img
          src={employee?.image}
          alt={employee?.name}
          className="w-full h-48 object-cover"
        />
        <div className="absolute top-4 right-4">
          <span className="bg-white/90 backdrop-blur-sm text-primary px-3 py-1 rounded-full text-sm font-medium">
            {employee?.tenure}
          </span>
        </div>
      </div>
      
      <div className="p-6">
        <div className="mb-4">
          <h3 className="font-heading font-semibold text-lg text-text-primary mb-1">
            {employee?.name}
          </h3>
          <p className="text-primary font-medium mb-2">{employee?.role}</p>
          <p className="text-sm text-text-secondary">{employee?.department}</p>
        </div>

        <blockquote className="text-text-secondary italic mb-4">
          "{employee?.quote}"
        </blockquote>

        <div className="mb-4">
          <h4 className="font-medium text-text-primary mb-2">Career Growth:</h4>
          <div className="space-y-2">
            {employee?.careerPath?.map((step, index) => (
              <div key={index} className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-primary rounded-full"></div>
                <span className="text-sm text-text-secondary">{step}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="flex items-center space-x-4 text-sm text-text-secondary">
          <div className="flex items-center space-x-1">
            <Icon name="MapPin" size={14} />
            <span>{employee?.location}</span>
          </div>
          <div className="flex items-center space-x-1">
            <Icon name="Award" size={14} />
            <span>{employee?.achievement}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeSpotlight;